import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from '@zurich/common/hooks';
import { Container } from '@zurich/ui/legacy/components';
import { InfoTextCard } from '../';
export function Error404({ image, customErrorTitle, customErrorSubtitle, }) {
    const { t } = useTranslation();
    return (_jsx(Container, { spacing: 5, children: _jsx(InfoTextCard, { title: customErrorTitle ?? t('portal:errors.404.title'), description: customErrorSubtitle ?? t('portal:errors.404.description'), illustration: image }) }));
}
